module.exports = __webpack_public_path__ + "img/bang1.e045042a.png";